<script setup lang="ts"></script>

<template>
  <div class="group animate-pulse">
    <div class="relative">
      <!-- Image skeleton -->
      <div class="w-full bg-actions-tertiary aspect-square md:aspect-[4/5]"></div>

      <!-- Discount badge skeleton -->
      <div class="bg-actions-tertiary w-16 h-12 absolute z-10 right-0 bottom-0"></div>
    </div>

    <div class="pr-3 mt-5 flex flex-col justify-between h-[400px]">
      <!-- Location skeleton -->
      <div class="flex items-center justify-between w-full">
        <div class="h-4 bg-actions-tertiary rounded w-1/3"></div>
        <div class="w-5 h-5 bg-actions-tertiary rounded"></div>
      </div>

      <!-- Title skeleton -->
      <div class="mt-[10px] mb-5 space-y-2">
        <div class="h-6 bg-actions-tertiary rounded w-3/4"></div>
        <div class="h-6 bg-actions-tertiary rounded w-1/2"></div>
      </div>

      <!-- Description skeleton -->
      <div class="mb-10 space-y-2">
        <div class="h-4 bg-actions-tertiary rounded w-full"></div>
        <div class="h-4 bg-actions-tertiary rounded w-5/6"></div>
        <div class="h-4 bg-actions-tertiary rounded w-4/6"></div>
      </div>

      <!-- Price skeleton -->
      <div class="h-6 bg-actions-tertiary rounded w-1/2 mb-5"></div>

      <!-- Old price skeleton -->
      <div class="flex items-center gap-5 mb-5">
        <div class="h-4 bg-actions-tertiary rounded w-1/4"></div>
        <div class="h-4 bg-actions-tertiary rounded w-1/4"></div>
      </div>

      <!-- Button skeleton -->
      <div class="h-12 bg-actions-tertiary rounded w-full"></div>
    </div>
  </div>
</template>
